var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2049 15.952L21 19.7462L19.7462 21L15.952 17.2049C14.5402 18.3366 12.7842 18.9522 10.9748 18.9496C6.57271 18.9496 3 15.3769 3 10.9748C3 6.57271 6.57271 3 10.9748 3C15.3769 3 18.9496 6.57271 18.9496 10.9748C18.9522 12.7842 18.3366 14.5402 17.2049 15.952ZM15.4274 15.2945C16.5519 14.138 17.18 12.5879 17.1774 10.9748C17.1774 7.54829 14.4013 4.77218 10.9748 4.77218C7.54829 4.77218 4.77218 7.54829 4.77218 10.9748C4.77218 14.4013 7.54829 17.1774 10.9748 17.1774C12.5879 17.18 14.138 16.5519 15.2945 15.4274L15.4274 15.2945Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.78dd9e672ff924703b46e51bec3088b9.svg";
export { ForwardRef as ReactComponent };